import React from 'react';
import MonthRecordingsUI from './MonthRecordingsUI';

const January = () => <MonthRecordingsUI month="January" />;

export default January;
